const PRECONNECT_ORIGINS = {
    URLS: [
        "https://cdn.lrkt-in.com"
    ]
}

export default PRECONNECT_ORIGINS;